import Axios from "@app/api/axios";

const deleteComment = (payload) => Axios.delete(`comments/${payload}`);

export default deleteComment;
